import React, { ReactElement } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

function CcxIconInfoCircleOutlined(): ReactElement {
    return <InfoCircleOutlined />;
}

export default CcxIconInfoCircleOutlined;
